import { ViewModel,View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { DataModelBuilderViewModel, DataModelClass, Method } from "../dataModelBuilder-viewModel";
import  { MethodBodyCodeEditorView } from "./methodBodyCodeEditor-view"

export class MethodBodyCodeEditorViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new MethodBodyCodeEditorView();
    }
    public getTypeId(): string {
        return "VM-12508437-212F-4E00-9472-247B95BE3AEB"
    }
    public set model(v: DataModelBuilderViewModel) { this._model = v; } public get model(): DataModelBuilderViewModel { return this._model;} private _model: DataModelBuilderViewModel;
    public set currentClass(v: DataModelClass) { this._currentClass = v; } public get currentClass(): DataModelClass { return this._currentClass;} private _currentClass: DataModelClass;
    public set currentMethod(v: Method) { this._currentMethod = v; } public get currentMethod(): Method { return this._currentMethod;} private _currentMethod: Method;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    closePopup(result?: any) {
    }
    confirm(code:string){
        this.code = code;
        this.closePopup(this.code);
    }
    close(){
        this.closePopup();
    }
}
